// extracted by mini-css-extract-plugin
export default {"get-started-page":"SideBar_get-started-page__Jkqa+","sidebar":"SideBar_sidebar__8lc3V","subsection":"SideBar_subsection__uuC3a"};